import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Users, Copy, ShieldCheck, Megaphone, Printer, HandHeart } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatCard from "@/components/StatCard";
import { Button } from "@/components/ui/button";

const fmt = (n) => new Intl.NumberFormat("ar-SA").format(n || 0);

export default function CharityDashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats/charitable").then((r) => setStats(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="p-6 lg:p-10">
      <PageHeader
        title="لوحة تحكم البوابة الخيرية"
        subtitle="عدد المستفيدين، الهويات الفريدة، والتكرارات"
        actions={
          <Button
            data-testid="charity-dashboard-print"
            variant="outline"
            onClick={() => window.open("/print/charitable/dashboard", "_blank")}
            className="border-emerald-900 text-emerald-900 hover:bg-emerald-50"
          >
            <Printer className="h-4 w-4 ml-2" /> طباعة
          </Button>
        }
      />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <StatCard testId="charity-total" icon={Users} label="إجمالي التسجيلات" value={fmt(stats?.total_registrations)} tone="emerald" />
        <StatCard testId="charity-unique" icon={ShieldCheck} label="مستفيدون فريدون" value={fmt(stats?.unique_beneficiaries)} tone="gold" />
        <StatCard testId="charity-duplicates" icon={Copy} label="التكرارات" value={fmt(stats?.duplicates)} tone="white" />
        <StatCard testId="charity-campaigns" icon={Megaphone} label="الحملات" value={fmt(stats?.campaigns_count)} tone="white" />
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <button onClick={() => navigate("beneficiaries")} className="p-8 bg-white rounded-2xl border border-emerald-900/10 text-right hover:-translate-y-0.5 hover:shadow-lg transition-all">
          <HandHeart className="h-8 w-8 text-amber-600 mb-3" />
          <div className="font-heading font-bold text-xl text-emerald-950">تسجيل المستفيدين</div>
          <div className="text-sm text-slate-500 mt-1">مع فحص التكرار الذكي عبر رقم الهوية</div>
        </button>
        <button onClick={() => navigate("reports")} className="p-8 bg-white rounded-2xl border border-emerald-900/10 text-right hover:-translate-y-0.5 hover:shadow-lg transition-all">
          <Users className="h-8 w-8 text-emerald-800 mb-3" />
          <div className="font-heading font-bold text-xl text-emerald-950">التقارير</div>
          <div className="text-sm text-slate-500 mt-1">عدد الفريدين، توزيع التكرارات، مطبوعات</div>
        </button>
      </div>
    </div>
  );
}
